<script>
export default
{
    name: 'waves',


    props:
    {
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div class='waves'>
                <inline-svg class='wave-shape top' src={require('@/assets/img/wave-shape.svg')} />
                    <div class='content-wrapper'>
                        <div class='content'>
                            { this.$slots.default }
                        </div>
                    </div>
                <inline-svg class='wave-shape bottom' src={require('@/assets/img/wave-shape.svg')} />
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
    },

    methods:
    {
    },

    components:
    {
    }
}
</script>

<style lang='less'>
.waves
{
    .wave-shape
    {
        &.top
        {
            fill: var(--theme-secondary-color);
        }
        &.bottom
        {
            fill: white;
            background: var(--theme-secondary-color);
        }
    }   

    .content-wrapper
    {
        margin: -1vh 0vw;
        padding: 1vh 0;
        background: var(--theme-secondary-color);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Waves.vue